@if (loadPage) {
	<lbca-loading class="show z-[1100]" position="relative" />
}

@if (
	!loadPage &&
	!configuration.disable &&
	!dynamicFormService.formControlStructure.moduleControl[configuration.id]?.hidden
) {
	<main
		[class.disabled]="configuration.disable"
		[class.dynamic-form-module-table]="formType === 'form-secondary'"
		class="dynamic-form-module"
	>
		<section
			#HeaderModule
			[class.required]="hasRequerid"
			[class.opened]="isOpen"
			[class.hasError]="hasError"
			(click)="configuration.disable ? null : troggleModule()"
			[class.dyc-header]="formType === 'form-primary'"
			[class.dyc-header-modal]="formType === 'modal'"
			[class.dyc-header-table]="formType === 'form-secondary'"
		>
			<section class="dyc-section-light">
				<div [class.filled]="isAllFilled" class="dyc-light"></div>
			</section>
			<section class="dyc-section-label">{{ configuration.label }}</section>
			<section class="dyc-section-empty"></section>
			<section class="dyc-section-validation">
				<div class="validation-helper"></div>
			</section>
			<section class="dyc-section-icon"><lbca-icon name="lucide:chevron-down"></lbca-icon></section>
		</section>
		<div class="container-motion-collapse-controler grid-expand" [class.expanded]="isOpen">
			<div
				class="relative"
				[style.pointer-events]="origin === 'task-form' && isOpen && !initialized ? 'none' : 'auto'"
			>
				@if (origin === 'task-form' && isOpen && !initialized) {
					<div class="form-unvaliable-background"></div>
					@if (waitingDelay) {
						<div class="form-unvaliable-message">
							<lbca-body-feedback type="col">
								<ng-container colMessagePrimary>
									{{ fieldsLabels['generic-infos-filled'] }}
								</ng-container>
								<ng-container colMessageSecondary>
									{{ fieldsLabels['generic-try-start-task'] }}
								</ng-container>
							</lbca-body-feedback>
						</div>
					}
				}
				@if (
					!configuration.disable &&
					!dynamicFormService.formControlStructure.moduleControl[configuration.id]?.locked
				) {
					@if (configuration.type === 'SUBFORM') {
						<lbca-sub-module-form
							class="h-full"
							[subFormModuleInstance]="subFormModuleInstance"
							[gridFormModuleInstance]="gridFormModuleInstance"
							(saveData)="saveData($event)"
							[entityData]="entityDataProcess"
							[cardData]="cardInfo"
							(errorApi)="erroApi($event)"
							[error]="hasError ? hasError : null"
							[disabled]="disabled"
							[initialized]="initialized"
							[dataAttr]="dataAttr"
							[context]="context"
							[flowId]="flowId"
							[dynamicFormService]="dynamicFormService"
							[properties]="configuration"
							[forceStateOpened]="isOpen"
							(validateCallback)="setValidationSubformCallback($event)"
							(setControlCloud)="cloudEmmitter($event)"
							[type]="formType"
						></lbca-sub-module-form>
					}
					@if (configuration.type === 'PARALLEL_TASK_TABLE') {
						<legalboxplus-parallel-table
							[dataAttr]="dataAttr"
							[dataProcess]="extData"
							[configuration]="configuration"
							[dynamicFormService]="dynamicFormService"
							(eventEmmitter)="eventParallelEmitter($event)"
							[entityData]="entityDataProcess"
							[subFormModuleInstance]="subFormModuleInstance"
							[cardData]="cardInfo"
						></legalboxplus-parallel-table>
					}
					@if (configuration.type === 'TASK_DISTRIBUTION') {
						<lbca-task-distribution
							[dynamicFormService]="dynamicFormService"
							[properties]="configuration"
							[flowId]="flowId"
							(validateCallback)="setValidationTaskDistributionCallback($event)"
							[dataAttr]="dataAttr"
							[cardData]="cardInfo"
							[externalData]="extData"
							[entityData]="entityDataProcess"
							[origin]="origin"
						></lbca-task-distribution>
					}
					@if (configuration.type === 'CCO') {
						<lbca-cco
							[properties]="configuration"
							[dynamicFormService]="dynamicFormService"
							[dataAttr]="dataAttr"
							(validateCallback)="setValidationCCOCallback($event)"
							[origin]="origin"
						></lbca-cco>
					}
					@if (configuration.type === 'CCO_V2') {
						<lbca-cco-v2
							[properties]="configuration"
							[dynamicFormService]="dynamicFormService"
							[cardData]="cardInfo"
							[dataAttr]="dataAttr"
							[entityData]="entityDataProcess"
							(validateCallback)="setValidationCCOCallback($event)"
							[origin]="origin"
						></lbca-cco-v2>
					}
					@if (configuration.type === 'SEARCH_MODULE') {
						<lbca-search-module
							[cardData]="cardInfo"
							[properties]="configuration"
							[origin]="origin"
						></lbca-search-module>
					}
					@if (configuration.type === 'LINKED_CASES_MODULE') {
						<legalboxplus-linked-cases
							[processId]="processId"
							[properties]="configuration"
							[origin]="origin"
						></legalboxplus-linked-cases>
					}
					@if (configuration.type === 'FORM_TEMPLATE') {
						<lbca-form-template
							[configuration]="configuration"
							[entityData]="dataAttr"
							[cardData]="cardInfo"
							[flowId]="flowId"
							[moduleDataRef]="moduleDataRef"
							(controllCloud)="cloudEmmitter($event)"
							[initialized]="initialized"
							(saveDataRef)="saveDataRef($event)"
						></lbca-form-template>
					}
					@if (configuration.type === 'CLAIM') {
						<lbca-sub-module-claim
							[dataAttr]="dataAttr"
							[disabled]="disabled"
							[cardData]="cardInfo"
							[flowId]="flowId"
							[properties]="configuration"
						></lbca-sub-module-claim>
					}
					@if (configuration.type === 'LEGAL_REQUEST') {
						<lbca-legalboxplus-legal-request
							[dataAttr]="dataAttr"
							[configuration]="configuration"
							[cardData]="cardInfo"
						></lbca-legalboxplus-legal-request>
					}
					@if (configuration.type === 'LEGAL_REQUEST_SIMPLE') {
						<lbca-legalboxplus-legal-request
							[dataAttr]="dataAttr"
							[configuration]="configuration"
							[cardData]="cardInfo"
							[simple]="true"
						></lbca-legalboxplus-legal-request>
					}
					@if (configuration.type === 'PARALLEL_TASK') {
						<legalboxplus-parallel-tasks
							[config]="configuration"
							[dataAttr]="dataAttr"
							[cardInfo]="cardInfo"
							[flowId]="flowId"
							[initialized]="initialized"
							[subFormModuleInstance]="subFormModuleInstance"
							[gridFormModuleInstance]="gridFormModuleInstance"
							[dynamicFormService]="dynamicFormService"
							[metadata]="configuration"
							[disabled]="disabled"
						></legalboxplus-parallel-tasks>
					}
					@if (configuration.type === 'FILE_UPLOAD') {
						<lbca-sub-module-file-upload
							[idEntity]="configuration.id"
							[cardData]="cardInfo"
							[flowId]="flowId"
							(validateCallback)="setValidationCallback($event)"
							[context]="context"
							(resetError)="resetError()"
							(cloudControl)="cloudEmmitter($event)"
							(errorApi)="erroApi($event)"
							[error]="hasError ? hasError : null"
							[disabled]="disabled"
							[initialized]="initialized"
							[dataAttr]="dataAttr"
							[origin]="origin"
							(setValidator)="
								subFormModuleInstanceForFileUpload(configuration.entityKey, 'value', !!$event)
							"
							[properties]="configuration"
						></lbca-sub-module-file-upload>
					}
				}
				@if (
					!configuration.disable &&
					dynamicFormService.formControlStructure.moduleControl[configuration.id]?.locked
				) {
					<div class="dyc-dependency-module">
						<div class="dyc-msg-container">
							<div class="flex flex-col">
								<div
									class="dyc-text-msg"
									*ngTryFor="
										let moduleLockMessage of dynamicFormService.formControlStructure.moduleControl[
											configuration.id
										]?.moduleLockMessages | keyvalue
									"
								>
									{{ moduleLockMessage.value }}
								</div>
							</div>
							<div class="emojis-shackle icon-box ml-[16px]"></div>
						</div>
					</div>
				}
			</div>
		</div>
	</main>
}
